const getDefaultState = () => {
    return {
        email: "E-Mail",
        geburtstag: "Geburtstag",
        // geschlecht: "Geschlecht",
        geschlecht: {
            type: "replace",
            label: "Geschlecht",
            replace: {
                Herr: "männlich",
                Frau: "weiblich",
            },
        },
        hausnummer: "Hausnummer",
        stocktuer: "Stiege/Stock/Tür",
        nachname: "Nachname",
        ort: "Ort",
        plz: "PLZ",
        strasse: "Straße",
        telefon: "Handynummer",
        // titel: "Titel",
        titel_prefix: "Titel vorangestellt",
        titel_suffix: "Titel nachgestellt",
        vorname: "Vorname",
        beruf: "Beruf",
        erwerbsart: "Erwerbsart",
    };
};

const state = getDefaultState();

export default {
    state,
};
